import BillCard from "@molecules/ObjectCard/ObjectCards/BillCard/BillCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function BillCardsView() {
    return (
        <CardsView.List<Bill>>
            {(bill, displayedAttributes) => <BillCard bill={bill} displayedAttributes={displayedAttributes} />}
        </CardsView.List>
    )
}
